// Versión del artifact actualmente VISIBLE en el panel, como variable
// de módulo: el store middleware de App.tsx la lee al enviar cada
// mensaje del usuario (channelData.visibleArtifactVersion) para que el
// ARTIFACT_VERSION_SELECTOR del backend sepa a qué versión se refiere
// "a esta cámbiale...". Se usa un módulo (no Redux) porque el
// middleware de Web Chat no tiene acceso al getState de la app.

let visibleArtifactVersion: string | null = null;

export const setVisibleArtifactVersion = (version: string | null) => {
  visibleArtifactVersion = version;
};

export const getVisibleArtifactVersion = () => visibleArtifactVersion;
